module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/58e4ffd30e88bef70209f8a88da3f5ca.png";